import { render, staticRenderFns } from "./JobCount.vue?vue&type=template&id=65ee2f17&"
import script from "./JobCount.vue?vue&type=script&lang=js&"
export * from "./JobCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports